import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import ThemeSettings from "./ThemeSettings";
const theme = ThemeSettings();
import FullLayout from "../FullLayout";

const Theme = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <FullLayout>{children}</FullLayout>
        </ThemeProvider>
    );
};

export default Theme;
